import React, { Component } from 'react'
import { Textfield } from '@scentregroup/ui'
import style from './index.module.scss'

class SearchField extends Component {
  handleSubmit = event => {
    event.preventDefault()
    // Trigger blur event to dismiss the Keyboard when user clicks Search in iOS.
    window.document.activeElement.blur()
  }
  render() {
    return (
      <form
        action="#" // Show Search button in iOS
        onSubmit={this.handleSubmit}
      >
        <Textfield type="search" classNames={style} {...this.props} />
      </form>
    )
  }
}

export default SearchField
